import React from 'react';
import { connect } from 'react-redux';
import UserModal from '../../molecules/user-modal';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import './amazon-polly.m.css';

class AmazonPolly extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      audioEnabled: false
    };
    this.openLoginModal = this.openLoginModal.bind(this);
  }

  openLoginModal() {
    UserModal.open(
      this.props.checkForMemberUpdated,
      this.props.publicIntegrations,
      this.props.integrations,
      this.props.member
    );
  }

  subscribetoListen() {
    window.scrollTo(0, 500);
  }

  listentoArticle = () => {
    this.setState({ audioEnabled: true });
  };
  render() {
    const cdn = this.props.cdn_image;
    const audioS3Key = get(this.props, ['story', 'story-audio', 's3-key']);
    const audioSrc = `//${cdn}/${audioS3Key}`;
    const audioAttributes = { controls: true, controlsList: 'nodownload' };
    return (
      <div styleName={`${this.state.audioEnabled ? 'audio' : 'amazon-wrapper'}`}>
        {!this.state.audioEnabled && <div styleName="headphones" />}
        {this.props.hasAccess ? (
          !this.state.audioEnabled ? (
            <div styleName="listen-container" onClick={this.listentoArticle}>
              Listen to Article
            </div>
          ) : (
            <audio controls autoPlay styleName="audio-wrapper" controlsList="nodownload">
              <source src={audioSrc} type="audio/mp3" {...audioAttributes} />
            </audio>
          )
        ) : this.props.member ? (
          <div styleName="listen-container" onClick={this.subscribetoListen}>
            Subscribe to Listen.
          </div>
        ) : (
          // integrate this with piano login as of now disabled
          // <div styleName="listen-container" onClick={this.openLoginModal}>
          //   Login to Listen
          // </div>
          <div />
        )}
      </div>
    );
  }
}

AmazonPolly.propTypes = {
  checkForMemberUpdated: PropTypes.func,
  publicIntegrations: PropTypes.object,
  integrations: PropTypes.object,
  member: PropTypes.object.isRequired,
  hasAccess: PropTypes.bool.isRequired,
  audioAttributes: PropTypes.object,
  cdn_image: PropTypes.string
};

const mapStateToProps = state => {
  return {
    publicIntegrations: state.qt.config['public-integrations'] || {},
    cdn_image: state.qt.config['cdn-image'] || '',
    integrations: state.qt.config.integrations || {}
  };
};

export default connect(mapStateToProps)(AmazonPolly);
